import { motion } from "framer-motion";
import { contact } from "../data/contact";
import { useLanguage } from "../context/LanguageContext";

export default function PrivacyPolicy() {
  const { t, dir, lang } = useLanguage();
  const p = t.privacyPage;
  const sections = [
    ...p.sections,
    {
      title: p.contactSectionTitle,
      body: p.contactSectionBody(contact.email, contact.whatsappDisplay),
    },
  ];

  return (
    <>
      <section
        dir={dir}
        lang={lang}
        className="relative pt-40 pb-6 px-5 sm:px-8"
        data-testid="privacy-page-hero"
      >
        <div className="mx-auto max-w-4xl">
          <div className="text-[11px] uppercase tracking-[0.3em] text-agency-gold flex items-center gap-3">
            <span className="h-px w-8 bg-agency-gold" /> {p.eyebrow}
          </div>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="mt-6 font-display text-4xl md:text-6xl font-black tracking-[-0.03em]"
          >
            {p.titleMain} <span className="gradient-gold-text">{p.titleGold}</span>
          </motion.h1>
          <p className="mt-4 text-sm text-white/45">{p.lastUpdated}</p>
        </div>
      </section>

      <section
        dir={dir}
        lang={lang}
        className="relative py-16 px-5 sm:px-8"
        data-testid="privacy-page-content"
      >
        <div className="mx-auto max-w-4xl space-y-10">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="text-sm sm:text-base text-white/65 leading-relaxed"
          >
            {p.shortVersion}
          </motion.p>
          {sections.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: Math.min(i * 0.05, 0.3) }}
            >
              <h2 className="font-display text-xl md:text-2xl font-bold">
                {s.title}
              </h2>
              <p className="mt-3 text-sm sm:text-base text-white/60 leading-relaxed">
                {s.body}
              </p>
            </motion.div>
          ))}
        </div>
      </section>
    </>
  );
}
